
import { convertSec2Str } from "@/utils/util";
import store from "@/store/index";
import {
  defineComponent,
  onMounted,
  reactive,
  toRefs,
} from "@vue/runtime-core";
import { useRoute, useRouter } from "vue-router";
import { touristApi } from "../../../api/farmerSpace";
import { stateType } from "./resourceDetail";
import { getFarmerFarmingList } from "../../../api/farmer";
import { ImagePreview } from "vant";
import PreviewVideo from "@/components/previewVideo/previewVideo.vue";
function stateInfo() {
  return {
    initInfo: {
      vrImg: [],
      dataImgs: [],
      video: [],
      farmerHeadImg: [],
      headImg:[]
    },
    backgroundImg: "",
    finished: false,
    loading: true,
    param: {
      lat: "",
      lng: "",
      page: 0,
      pageSize: 10,
      sourceId: "",
    },
    resList: [],
    showVideos: false,
    videoUrl: "",
    total: 0,
  };
}
const useEvent = (state: stateType, router: any) => {
  const toVideoImage = (type: number) => {
    console.log(type);
    router.push({
      path:"/resourceImgVideo",
      query:{
        type,
        id:state.initInfo.sourceId
      }
    })
  };
  const toFarmer = ()=>{
    router.push({
      path:"/farmerDetail/"+state.initInfo.farmerId
    })
  }
  const onLoad = () => {
    state.param.page = ++state.param.page;
    getData();
  };
  const getData = async () => {
    if (state.resList.length == state.total && state.total != 0) {
      return;
    }
    const res: any = await getFarmerFarmingList(state.param);
    state.loading = false;
    state.total = res.data.data.total;
    res.data.data.records.map((item: any) => {
      if (item.videos.length != 0) {
        item.videos.forEach((value: any) => {
          value.time = convertSec2Str(value.time);
        });
      }
      item.workTime = item.workTime.replace(/-/g,'.')
      state.resList.push(item);
      return item;
    });
    if (state.resList.length == state.total) {
      state.finished = true;
    }
  };
  const getInit = async () => {
    const res: any = await touristApi(
      state.param.sourceId,
      state.param.lat,
      state.param.lng
    );
    state.initInfo = { ...state.initInfo, ...res.data.data };
    state.initInfo.dataImgs = [
      ...res.data.data.img,
      ...res.data.data.shotImg,
      ...res.data.data.detailImg,
    ];
    if (state.initInfo.vrImg.length != 0) {
      state.backgroundImg = `https://qnui.xfarmer.com/xfarmer-ui/trace/%E7%BB%84%20537%402x.png`;
    } else if (
      state.initInfo.dataImgs.length == 0 &&
      state.initInfo.vrImg.length == 0 &&
      state.initInfo.video.length != 0
    ) {
      state.backgroundImg = `https://qnui.xfarmer.com/xfarmer-ui/trace/组 538@2x.png`;
    } else if (
      state.initInfo.dataImgs.length == 0 &&
      state.initInfo.video.length == 0
    ) {
      state.backgroundImg = `https://qnui.xfarmer.com/xfarmer-ui/h5FarmerSpace/source_bg.png`;
    }
  };
  const previewImage = (parid: string, id: string) => {
    let arr = [] as any,
      startPosition: number = 1;
    state.resList.forEach((item: any) => {
      if (item.id == parid) {
        arr = item.images.map((value: any, idx: number) => {
          if (id == value.id) {
            startPosition = idx;
          }
          return value.url;
        });
      }
    });
    console.log(arr);

    ImagePreview({
      images: arr,
      startPosition,
      closeable: true,
    });
  };
  const playVideo = (url: string) => {
    state.videoUrl = url;
    state.showVideos = true;
  };
  const toDetail = (id:string)=>{
    router.push({
        path: "/infoDetail/" + id,
      });
  }
  return { onLoad, getData, getInit, previewImage, playVideo, toVideoImage,toDetail,toFarmer };
};
export default defineComponent({
  components: {
    PreviewVideo,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const state = reactive<stateType>(stateInfo());
    console.log(route.params.id)
    const { getInit } = useEvent(state, route);
    let { lat, lng } = store.state.lngLat;
    state.param.lat = lat;
    state.param.lng = lng;
    state.param.sourceId = route.params.id as string;
    onMounted(() => {
      getInit();
    });
    return {
      ...toRefs(state),
      ...useEvent(state, router)
    };
  },
});
